import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  TableLoops,
  API,
  DisplayActions,
  GlobalActions,
  NavigationHelper,
  VibeButton,
  viAdd,
  withRouter,
} from 'vibeguide';
import LoopSidebar from '../../../../Messages/Loops/Sidebar/LoopSidebar';
import './Loops.scss';

class Loops extends Component {
  componentDidMount() {
    const qs = NavigationHelper.getParams() || {};
    const isNew = qs.type === 'new';
    const isView = qs.loopId && qs.type !== 'new';

    if (isNew || isView) {
      setTimeout(() => {
        this.sidebar(qs.type, qs.loopId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.loopId || qs.type === 'new') {
        this.sidebar(qs.type, qs.loopId);
      }
    }
  }

  showDisplayPlayer = async (e, messages) => {
    const {
      setDisplay,
    } = this.props;

    e.preventDefault();
    e.stopPropagation();

    setDisplay({
      show: true,
      messages,
      isLoop: true,
    });
  };

  showSidebarDisplayPlayer = async (messages) => {
    const {
      setDisplay,
    } = this.props;

    setDisplay({
      show: true,
      messages,
      isLoop: true,
    });
  };

  sidebar = (type, loopId = null) => {
    const {
      setPanel,
      // currentLocation,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      width: 600,
      children: (
        <LoopSidebar
          loopId={loopId}
          showDisplayPlayer={this.showSidebarDisplayPlayer}
          isNew={type === 'new'}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    const {
      currentLocation: {
        _id: locationId,
      },
      user,
    } = this.props;

    return (
      <div className="Loops">
        <TableLoops
          columns={[
            '.',
            'Name',
            'Description',
            'Company',
            'Duration',
            '# Of Locations',
            'Tags',
            '...',
          ]}
          fetch={API.Location.listLoops}
          fetchProps={{
            filters: {
              _id: locationId,
            },
          }}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Loops',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Loops',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: false,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          cardProps={{
            requireFilter: true,
          }}
          rowLink={{
            loopId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'loop.delete' },
          ]}
          toolbarProps={{
            customButtons: user.can('loop.create')
              ? [
                (
                  <VibeButton
                    key="button-new-message"
                    text="New Loop"
                    color="primary"
                    icon={viAdd}
                    tooltip="New Message"
                    tooltipProps={{
                      placement: 'top',
                    }}
                    link={NavigationHelper.updateParams({
                      type: 'new',
                    })}
                  />
                ),
              ]
              : [],
          }}
          showDisplayPlayer={this.showDisplayPlayer}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
    currentLocation: state.locations.currentLocation,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
  setDisplay: DisplayActions.setDisplay,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Loops));
